import { Card, CardContent, CardHeader, Typography} from '@mui/material';
import ContactForm from './ContactForm';
import { useTranslation } from 'react-i18next';

function ContactCard() {
  const { t } = useTranslation();
  return (
    <Card elevation={0} raised sx={{ margin: 'auto', m: 0 }}>
      <CardHeader 
        title={
          <>
            <Typography variant="h5" gutterBottom>
              {t('contactHeader.title')}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {t('contactHeader.subtitle')}
            </Typography>
          </>
        }
      />
      <CardContent>
        <ContactForm />
      </CardContent>
    </Card>
  );
}

export default ContactCard;